// extracted by mini-css-extract-plugin
module.exports = {"colorSwatch":"ColorSwatch_colorSwatch__XmYjf","box":"ColorSwatch_box__AeB4c","title":"ColorSwatch_title__1MzXc","color":"ColorSwatch_color__3lq54"};